import {Typography} from "@mui/material";
import {DW_SM, PD_XLG} from "shared/dimens";
import React from "react";
import {BaseFragmentProps, BaseFragmentState} from "shared/BaseFragment";
import {BaseApp, getProvisioningId} from "./BaseApp";
import {StyledBoxColumn} from "./StyledComponents";
import {getMemberAuth} from "./auth";
import {DialogFragment} from "./PageFragment";

export type DebugFragmentProps = BaseFragmentProps & {
  extras?: Map<string, string>,
}

type DebugFragmentState = BaseFragmentState & {}

export class DebugFragment extends DialogFragment<DebugFragmentProps, DebugFragmentState> {

  protected renderContainerContent(): React.ReactElement | null {
    const extras = [...(this.props.extras?.entries() || [])];
    const appName = BaseApp.CONTEXT.getAppConfig().name;
    const appVersion = BaseApp.CONTEXT.getAppConfig().version || "1.0.0";
    const memberId = getMemberAuth()?.getMemberId();
    const clientId = BaseApp.CONTEXT.getAppPrefs().getClientId();
    const provisioningId = getProvisioningId();
    return <StyledBoxColumn style={{display: "flex", flexDirection: "column", width: DW_SM, padding: PD_XLG}}>
      <Typography>{`App name: ${appName}`}</Typography>
      <Typography>{`App version: ${appVersion}`}</Typography>
      <Typography>{`Member ID: ${memberId}`}</Typography>
      <Typography>{`Client ID: ${clientId}`}</Typography>
      <Typography>{`Provisioning ID: ${provisioningId}`}</Typography>
      {extras.map(entry => <Typography>{`${entry[0]}: ${entry[1]}`}</Typography>)}
    </StyledBoxColumn>;
  }
}
